<template>
  <div class="d-flex flex-column wrapper">
    <div class="d-flex justify-content-between mb-1">
      <div>
        <span>
          {{ headerTitle }}
        </span>
        <span class="text-secondary-light">
          ({{ headerSubTitle }})
        </span>
      </div>
      <div
        class="d-flex"
        style="gap: 10px;">
        <button
          v-for="(link, index) in links"
          v-if="accountMapping[link.ref].items.length > 0"
          :key="index"
          class="btn btn-sm btn-light"
          style="height: 29px;"
          @click="link.onClick(link)">
          {{ link.text }}
          <i class="fas fa-link"/>
        </button>
      </div>
    </div>
    <!-- Labels -->
    <div class="lines mb-1">
      <div class="main-item">
        <span>
          {{ itemTitle }}
        </span>
      </div>
      <div class="debit-credit">
        <div class="d-flex">
          <span
            :class="[]"
            class="text-secondary-light w-50"
            style="padding-left: 12px;"
          >
            {{ $t('apps.accounting.journal_mapping.debit') }}
          </span>
          <span
            :class="[]"
            class="text-secondary-light w-50"
            style="padding-left: 12px;"
          >
            {{ $t('apps.accounting.journal_mapping.credit') }}
          </span>
        </div>
      </div>
    </div>
    <!-- Form -->
    <div class="d-flex flex-column">
      <div
        v-for="(item, index) of form.items"
        v-if="!item.hide"
        :key="index"
        class="lines mb-2"
      >
        <div class="main-item">
          <input
            :value="item.text"
            :disabled="true"
            type="text"
            class="form-control text-select-all"
            style="border-right: none;border-radius: .25rem 0 0 .25rem;"
          >
        </div>
        <div class="debit-credit">
          <div class="input-group">
            <BaseDropdown
              v-model="item.debit_account"
              :options="accountOptions"
              :disabled="disabledDebit || item.debit_account_disabled"
              style="border-radius: 0;"
            />
            <BaseDropdown
              v-model="item.credit_account"
              :options="accountOptions"
              :disabled="disabledCredit || item.credit_account_disabled"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getMasterDataText } from '@/helpers'
import { cloneDeep } from 'lodash'

export default {
  props: {
    keyName: {
      type: String,
    },
    headerTitle: {
      type: String,
    },
    headerSubTitle: {
      type: String,
    },
    itemTitle: {
      type: String,
    },
    links: {
      type: Array,
    },
    items: {
      type: Array,
    },
    disabledDebit: {
      type: Boolean,
    },
    disabledCredit: {
      type: Boolean,
    },
    accountMapping: {
      type: Object,
    },
  },

  data() {
    return {
      form: {
        items: [],
      },
    }
  },

  computed: {
    ...mapGetters({
      chartOfAccountsList: 'chartOfAccountsList',
    }),
    accountOptions() {
      const options = this.chartOfAccountsList.map((account) => {
        const accountCode = account.account_code
        const accountName = getMasterDataText(account.account_name, this.$t)
        return {
          text: `${accountCode} - ${accountName}`,
          value: accountCode,
        }
      })
      return [
        {
          text: this.$t('placeholder.select'),
          value: null,
        },
        ...options,
      ]
    },
  },

  watch: {
    form: {
      handler: function () {
        this.$emit('onChange', this.keyName, this.form.items)
      },
      deep: true,
    },
  },

  created() {
    this.form.items = cloneDeep(this.items)
  },
}
</script>

<style scoped>
.wrapper {
  background-color: #fff;
  border: 1px solid rgba(0,0,0,.1);
  padding: 15px;
  border-radius: .25rem;
}

.lines {
  display: flex;
  /* gap: 10px; */
}
.lines:last-of-type {
  margin-bottom: 0 !important;
}

.lines .main-item,
.lines .debit-credit {
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/custom/AccountMapping.vue